module.exports = __webpack_public_path__ + "04_short_black.1f637b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_short_black.png
// module id = JAqu
// module chunks = 0